"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoleChangeRequestModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _DialogContent = require("../primitives/DialogContent");
var _useUISettings = require("./AppData/useUISettings");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var RoleChangeRequestModal = function RoleChangeRequestModal() {
  var _roleChangeRequest$re, _roleChangeRequest$ro;
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var isHeadless = (0, _useUISettings.useIsHeadless)();
  var roleChangeRequest = (0, _reactSdk.useHMSStore)(_reactSdk.selectRoleChangeRequest);
  if (!(roleChangeRequest !== null && roleChangeRequest !== void 0 && roleChangeRequest.role) || isHeadless) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.RequestDialog, {
    title: "Role Change Request",
    onOpenChange: function onOpenChange(value) {
      return !value && hmsActions.rejectChangeRole(roleChangeRequest);
    },
    body: "".concat(roleChangeRequest === null || roleChangeRequest === void 0 ? void 0 : (_roleChangeRequest$re = roleChangeRequest.requestedBy) === null || _roleChangeRequest$re === void 0 ? void 0 : _roleChangeRequest$re.name, " has requested you to change your role to ").concat(roleChangeRequest === null || roleChangeRequest === void 0 ? void 0 : (_roleChangeRequest$ro = roleChangeRequest.role) === null || _roleChangeRequest$ro === void 0 ? void 0 : _roleChangeRequest$ro.name, "."),
    onAction: function onAction() {
      hmsActions.acceptChangeRole(roleChangeRequest);
    },
    actionText: "Accept"
  });
};
exports.RoleChangeRequestModal = RoleChangeRequestModal;